module.exports = __webpack_public_path__ + "static/media/heart-all-icon.0b5b33d0.svg";